import { Section, Container, Eyebrow, DisplayH1 } from "@/components/Layout";
import { Link } from "react-router-dom";

const ROLES = [
  { title: "Head Trainer", location: "Chicago · On-site", type: "Full time" },
  { title: "Behavior Specialist", location: "Denver · On-site", type: "Full time" },
  { title: "Global Ambassador", location: "Global · Remote", type: "Contract" },
  { title: "Video Documentarian", location: "Chicago · Hybrid", type: "Full time" },
  { title: "Country Director – Portugal", location: "Lisbon · On-site", type: "Full time" },
  { title: "Franchise Partner", location: "Multi-region", type: "Partnership" },
  { title: "Curriculum Editor", location: "Remote", type: "Full time" },
  { title: "Junior Trainer Intern", location: "Chicago", type: "Internship" },
];

export default function Careers() {
  return (
    <>
      <Section testid="careers-hero" className="pt-40 pb-16">
        <Container>
          <Eyebrow>Careers at Wolfkeeper</Eyebrow>
          <DisplayH1 className="mt-6 max-w-4xl">Build the future of the human-dog relationship.</DisplayH1>
          <p className="mt-8 max-w-2xl text-lg text-[color:var(--wk-bone-dim)] leading-relaxed">
            We're hiring across faculty, media, technology, and global operations. Every role
            includes tuition benefits at the University, family healthcare, and dog days.
          </p>
        </Container>
      </Section>
      <Section testid="careers-roles" className="pb-32">
        <Container>
          <div className="divide-y divide-white/10 border-y border-white/10">
            {ROLES.map((r) => (
              <div key={r.title} className="flex flex-col md:flex-row md:items-center gap-3 md:gap-10 py-6 hover:bg-white/[0.02] px-2 group cursor-pointer">
                <div className="flex-1 font-serif-display text-2xl group-hover:text-[color:var(--wk-gold)] transition-colors">{r.title}</div>
                <div className="text-sm text-[color:var(--wk-bone-dim)] md:w-64">{r.location}</div>
                <div className="overline text-[10px] md:w-32">{r.type}</div>
                <Link to="/contact" className="btn-ghost h-10 md:w-40 text-sm">Apply</Link>
              </div>
            ))}
          </div>
        </Container>
      </Section>
    </>
  );
}
